/**
 * Algolia InstantSearch (Shopify app): accordion facets — keep at most one
 * checkbox-driven facet panel open at a time within #algolia-shopify-instantsearch,
 * and close open panels on outside pointerdown.
 */
(function () {
  if (window.isB2B) {
    return;
  }

  var ROOT_ID = 'algolia-shopify-instantsearch';
  var WRAPPER_SEL = '.ais-facet-dropdown-wrapper';

  function getRoot() {
    return document.getElementById(ROOT_ID);
  }

  function closeOpenFacetDropdowns(root) {
    root.querySelectorAll('input.ais-dropdown-checkbox:checked').forEach(function (cb) {
      cb.checked = false;
    });
  }

  document.addEventListener(
    'change',
    function (e) {
      var t = e.target;
      if (!t || t.type !== 'checkbox' || !t.classList.contains('ais-dropdown-checkbox')) return;

      var root = getRoot();
      if (!root || !root.contains(t) || !t.checked) return;

      root.querySelectorAll('input.ais-dropdown-checkbox').forEach(function (cb) {
        if (cb !== t) cb.checked = false;
      });
    },
    true
  );

  document.addEventListener(
    'pointerdown',
    function (e) {
      var root = getRoot();
      if (!root) return;
      if (!root.querySelector('input.ais-dropdown-checkbox:checked')) return;

      var target = e.target;
      if (!(target instanceof Element)) return;

      var wrapper = target.closest(WRAPPER_SEL);
      if (wrapper && root.contains(wrapper)) return;

      closeOpenFacetDropdowns(root);
    },
    true
  );
})();
